const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkPlayed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215688%,92.156863%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 24 12 C 24 18.628906 18.640625 24 12 24 C 5.359375 24 0 18.628906 0 12 C 0 5.371094 5.378906 0 12 0 C 18.621094 0 24 5.378906 24 12 Z M 24 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,50.980395%,80.392158%)",
      fillOpacity: 1
    },
    d: "M 16.800781 8.601562 L 10.628906 14.761719 L 7.871094 12 C 7.519531 11.660156 6.949219 11.660156 6.601562 12 C 6.25 12.351562 6.25 12.929688 6.601562 13.28125 L 9.988281 16.671875 C 10.160156 16.839844 10.390625 16.941406 10.628906 16.941406 C 10.871094 16.941406 11.101562 16.839844 11.269531 16.671875 L 18.070312 9.871094 C 18.421875 9.511719 18.421875 8.941406 18.070312 8.601562 C 17.71875 8.25 17.148438 8.25 16.800781 8.601562 Z M 16.800781 8.601562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkPlayed);
export default __webpack_public_path__ + "static/media/mark-played.12ff9acde0233bd0841e9c2a7d670f54.svg";
export { ForwardRef as ReactComponent };